import { render, staticRenderFns } from "./EditStaffAssignment.vue?vue&type=template&id=5a7a512a"
import script from "./EditStaffAssignment.vue?vue&type=script&lang=js"
export * from "./EditStaffAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports